module.exports = __webpack_public_path__ + "static/img/qh_fs.671a160.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/qh_fs.jpg
// module id = hWd1
// module chunks = 0